import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { APIErrorsModel } from './models/apimessages.model';
import { LoadingService } from './services/loading.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  lsAPImessages: APIErrorsModel[] = [];
  setLSAPImessages: APIErrorsModel[] = [];
  isLoading$: Observable<boolean>;

  constructor(
    public loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
  ) {
    this.isLoading$ = this.loadingService.isLoading$;
  }
  
  title = 'angular-engenuity';

  ngOnInit() {
    this.loadGoogleMapsScript();
  }

  loadGoogleMapsScript() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=&v=weekly`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  ngAfterViewInit() {
    // Since we're using OnPush, we need to mark for check when loading state changes
    this.cdr.markForCheck();
  }
}
